export default "<app-analytics-by-category></app-analytics-by-category>\r\n<app-analytics-by-breakdown></app-analytics-by-breakdown>"